import { useUserInfoStore } from "@/stores/userInfoStore";
import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from) => {
	document.title = to.meta.title || "Operator Platform";
	const { userInfo, getUserInfo } = useUserInfoStore();
	// 不需要登录的页面
	if (["Login", "ResetPassword", "Register"].includes(to.name)) return true;
	// 登录验证
	if (!Object.keys(userInfo || {}).length) {
		const res = await getUserInfo();
		if (res?.result) return true;
		return { name: "Login" };
	}
	// 正常跳转
	return true;
});

export default router;
